<template>
  <div class="page_footer">
      <div class="container_box footer_box">
        <div class="row">
          <div class="col-md-4">
            <div class="title"><span class="lang_serviceTel">服务连接</span></div>
            <a class="link_a" target="_blank" href="http://www.rizhao.gov.cn/"> 日照市人民政府</a>
            <a class="link_a" target="_blank" href="http://hrss.rizhao.gov.cn/"> 日照人力资源和社会保障局</a>
            <a class="link_a" target="_blank" href="http://www.rz110.gov.cn/"> 日照警务网</a>
            <a class="link_a" target="_blank" href="http://www.shandong.gov.cn/"> 山东省人民政府</a>
            <a class="link_a" target="_blank" href="http://hrss.shandong.gov.cn/"> 山东省人力资源和社会保障厅</a>
          </div>
          <div class="col-md-5">
            <div class="title"><span class="lang_serviceTel">联系</span></div>
            <a class="link_a"> 客服电话：0633-2270989</a>
            <a class="link_a"> 反馈建议：rzrzcyy@163.com</a>
            <a class="link_a"> 工作时间：9:00-18:00（周一至周五）</a>
            <a class="link_a"> 地址：日照市东港区莒州路南与临沂路西交汇处 </a>
          </div>
          <div class="col-md-3">
            <div class="img_box fl">
              <img src="../assets/images/ewm1.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
     }
  },
  methods: {
   //底部连接
    goHome(){
      this.$router.push('/');
    },
    goPark(){
      this.$router.push('/park');
    },
    goEnterPark(){
      this.$router.push('/enter-park');
    },
    goHotspot(){
      this.$router.push('/hotspot');
    },
    goService(){
      this.$router.push('/service');
    },
    goPartBuild(){
      this.$router.push('/part-building')
    },
    goWisdom(){
      this.$router.push('/wisdom')
    },
  },


};
</script>



// WEBPACK FOOTER //
// src/components/bottomFooter.vue